module.exports = __webpack_public_path__ + "img/Aspects-Sources.1dbe0c2e.svg";